{#each collection as item}
  <GridItemCard 
    on:click={() => { location="#reporte?id="+item.id; }}
    id={item.id}
    title={item.title}
    descr={item.descr}
    state={item.state}
    updated={item.updated_date}
    icon="xls"
    />
{/each}

<script>
  import { onMount } from 'svelte'
  import API from '@/api'
  import { Panel, Icon, Box } from 'svelte-stylo'
  import { GridItemCard } from '@/components'
  import { activeReportDefs } from '@/states'

  let collection = [];

  onMount(async () => {
    collection = await API.reportDefs.collection();

    collection = collection.filter((t) => {
      return (t.state !== 'X');
    })

    collection = collection.map((t) => {
      t.href = '#reporte?id='+t.id;
      return t;
    })

    activeReportDefs.set(collection);
  })

</script>
